import {
  FetchFolioDocumentOriginalResponse,
  FolioDocumentRef,
} from "@/types/folio/folio-document"

import { FolioForwardingEmailsResponse } from "@/lib/folio-forwarding-api"
import { baseApi } from "./base-api"

export const folioDocumentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFolioForwardingEmails: builder.query<
      FolioForwardingEmailsResponse,
      void
    >({
      query: () => ({ url: "/api/folio_forwarding_emails" }),
      providesTags: ["FolioForwardingEmails"],
    }),
    // The uploaded file itself, base64 encoded. Files can be large, so the
    // cache drops one soon after nothing is showing it.
    getFolioDocumentOriginalContent: builder.query<
      FetchFolioDocumentOriginalResponse,
      FolioDocumentRef
    >({
      query: (ref) => ({
        url: `/api/folio_documents/original_content/${ref}`,
      }),
      keepUnusedDataFor: 10,
    }),
  }),
})

export const {
  useGetFolioForwardingEmailsQuery,
  useGetFolioDocumentOriginalContentQuery,
} = folioDocumentsApi
